/**
 * EarlyAccessLayout — scopes the WalletProvider to the /early-access subtree.
 *
 * No other landing route sees this provider; the marketing site stays wallet-free.
 * All consent UI lives below this layout via <Outlet/>.
 */

import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { WalletProvider, WalletModal, AlertPopup } from "@thema/ui/wallet";

const WC_PROJECT_ID = import.meta.env.VITE_WALLET_CONNECT_PROJECT_ID || "";

export default function EarlyAccessLayout() {
  // Discourage indexing of the entire /early-access subtree.
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <WalletProvider
      projectId={WC_PROJECT_ID}
      appMetadata={{
        name: "Thema Early Access",
        description: "Risk acknowledgement and on-chain consent for Thema's experimental vault.",
        url: typeof window !== "undefined" ? window.location.origin : "",
        icons: ["/favicon.png"],
      }}
    >
      <Outlet />
      <WalletModal />
      <AlertPopup position="top-right" />
    </WalletProvider>
  );
}
